import VideoModule from './VideoModule';

export default VideoModule;
